import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';

@Component({
  selector: 'app-port-infopage',
  templateUrl: './port-infopage.component.html',
  styleUrls: ['./port-infopage.component.css'],
})
export class PortInfopageComponent implements OnInit, OnDestroy {
  userdata?: UserData;
  inputdate!: string | null;
  portcity!: string | null;
  LoginData: any;
  employeeData?: EmployeeData;
  shpId: number | undefined;

  validsession: boolean | undefined;
  private reloadTimerId?: ReturnType<typeof setTimeout>;

  constructor(
    private sesssionvalidator: SessionvalidateService,
    private router: Router,
    private route: ActivatedRoute,
    private EmployeeLoginService: EmployeeloginService
  ) {}

  ngOnInit(): void {
    this.reloadTimerId = setTimeout(() => {
      location.reload();
    }, 86400000);
    this.inputdate = this.route.snapshot.queryParamMap.get('inputdate');
    this.portcity = this.route.snapshot.queryParamMap.get('portcity');

    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo != undefined) {
      this.checkLogin();
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/login']);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.reloadTimerId) {
      clearTimeout(this.reloadTimerId);
    }
  }

  checkLogin() {
    this.LoginData = this.EmployeeLoginService.GetEmployeeLogin(
      this.employeeData?.EmployeeNo,
      this.employeeData?.LastName
    ).subscribe((LoginData) => this.setCheckLogin(LoginData));
  }

  setCheckLogin(resdata: any) {
    this.LoginData = resdata;
    if (this.LoginData.GetEmployeeLogin.Result.Status != 'A') {
      this.router.navigate(['/adminlogin']);
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/shipselect']);
      }
    }
  }
}
